import useStudentStore from '../../../main/zustand/store'
import { dateStrToHumanDateStr } from 'parts/utils/time'

export function useGetRegisterDate(): string {
	const student = useStudentStore((store) => store.student)
	if (!student) return ''

	return dateStrToHumanDateStr(student.createdAt) + ' года'
}
